module.exports = __webpack_public_path__ + "static/img/ecsc-join.44f2e7d.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ecsc-join.gif
// module id = 1IXM
// module chunks = 6